import { render } from "./Midmenuchat.vue?vue&type=template&id=85a8da42&scoped=true"
import script from "./Midmenuchat.vue?vue&type=script&lang=js"
export * from "./Midmenuchat.vue?vue&type=script&lang=js"

import "./Midmenuchat.vue?vue&type=style&index=0&id=85a8da42&lang=scss"
import "./Midmenuchat.vue?vue&type=style&index=1&id=85a8da42&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a8da42"]])

export default __exports__